module.exports = __webpack_public_path__ + "static/media/Employer_branding_1_A.8801630f.png";